import { Injectable } from '@angular/core';
import { CanActivate, Router, UrlTree } from '@angular/router';
import { Observable, catchError, map, of } from 'rxjs';
import { AdminUserService } from './admin-user.service';

@Injectable({ providedIn: 'root' })
export class AdminGuard implements CanActivate {
  /** Prépare les dépendances utilisées pour décider si la navigation est autorisée. */
  constructor(private adminService: AdminUserService, private router: Router) {}

  /** Autorise la navigation si la session possède les droits attendus. */
  canActivate(): Observable<boolean | UrlTree> {
    return this.adminService.listAssignableRoles().pipe(
      map(() => true),
      catchError(() => of(this.router.createUrlTree(['/access-denied'])))
    );
  }
}
